import {
  DEAL_SHEET_PRIORITY,
  DEAL_SHEET_PROGRAM_TYPE,
  DEAL_SHEET_TARGET_TYPE,
  ACTIVE_STATUS_COMMON,
} from '@/utils/enum';
import {
  DEAL_SHEET_PRIORITY_NAME,
  DEAL_SHEET_PROGRAM_TYPE_NAME,
  DEAL_SHEET_TARGET_TYPE_NAME,
} from '@/utils/enum-name';

export const PRIORITY_OPTIONS = [
  {
    id: DEAL_SHEET_PRIORITY.LOW,
    name: DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.LOW],
  },
  {
    id: DEAL_SHEET_PRIORITY.MEDIUM,
    name: DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.MEDIUM],
  },
  {
    id: DEAL_SHEET_PRIORITY.HIGH,
    name: DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.HIGH],
  },
];

export const PROGRAM_TYPE_OPTIONS = [
  {
    id: DEAL_SHEET_PROGRAM_TYPE.JBP,
    name: DEAL_SHEET_PROGRAM_TYPE_NAME[DEAL_SHEET_PROGRAM_TYPE.JBP],
  },
  {
    id: DEAL_SHEET_PROGRAM_TYPE.HOT_SALE,
    name: DEAL_SHEET_PROGRAM_TYPE_NAME[DEAL_SHEET_PROGRAM_TYPE.HOT_SALE],
  },
];

export const TARGET_TYPE_OPTIONS = [
  {
    id: DEAL_SHEET_TARGET_TYPE.SALE_OUT,
    name: DEAL_SHEET_TARGET_TYPE_NAME[DEAL_SHEET_TARGET_TYPE.SALE_OUT],
  },
  {
    id: DEAL_SHEET_TARGET_TYPE.SALE_IN,
    name: DEAL_SHEET_TARGET_TYPE_NAME[DEAL_SHEET_TARGET_TYPE.SALE_IN],
  },
];

export const ACTIVE_STATUS_OPTIONS = [
  {
    id: ACTIVE_STATUS_COMMON.ENABLED,
    name: 'Hoạt động',
  },
  {
    id: ACTIVE_STATUS_COMMON.DISABLED,
    name: 'Tạm ngưng',
  },
];
export const SEARCH_TYPE = {
  PRODUCT: 2,
  CATEGORY: 3,
  BRAND: 4,
};

export const DEFAULT_PRIORITY = DEAL_SHEET_PRIORITY.MEDIUM;

export const TABLE_PAGE_SIZE = 10;
